const theme = {
  colors: {
    primary: '#00833D',
    secondary: "#FF7900",
    green: '#65BF54',
    red: '#EF2E2E',
    orange: '#F8913F',
    blue: '#0FB9C5',
    disabled: '#EFEFEF',
    textDisabled: '#cccccc',
    lightsalmon: '#ffaf78',
    white: '#FFFFFF',
    black: '#00080C',
    snow: '#FAFAFA',
    mediumpurple: '#B27BFF',
    sandybrown: '#FF9F40',
    darkcyan: '#00BF6C',
    mediumspringgreen: '#00D496',
    dimgray: '#5D5C5C',
    darkorange: '#ff8c00',
    teal: '#006E75',
    darkgray: '#A6A5A5',
    darkslategray: '#333649',
    light_red: '#ffd9d9',
    light_blue: '#e4f6f8',
    forest_green: '#0b773f',
    lightslategray: '#909293',
    silver: '#bfc1c3',
    light_primary: '#F0E5FF',
    light_yellow: '#FFF1E3',
    light_green:"#D7FEE4",
    yellow: '#FFDD00',
    transparent: 'rgba(0, 0, 0, 0)',
    bg: '#F9F9F9',
  },
  textSize: {
    title: 16,
    subTitle: 14,
    miniTitle: 11,
  },
  fontWeight: {
    title: 600,
    subTitle: 400
  }
};

export default theme;
